'use strict';

/* Expose. */
module.exports = visitParents;

/* Visit. */
function visitParents(tree, type, visitor) {
  var stack = [];

  if (typeof type === 'function') {
    visitor = type;
    type = null;
  }

  one(tree);

  /* Visit a single node. */
  function one(node) {
    var result;

    if (!type || node.type === type) {
      result = visitor(node, stack.concat());
    }

    if (node.children && result !== false) {
      return all(node.children, node);
    }

    return result;
  }

  /* Visit children in `parent`. */
  function all(children, parent) {
    var length = children.length;
    var index = -1;
    var child;

    stack.push(parent);

    while (++index < length) {
      child = children[index];

      if (child && one(child) === false) {
        return false;
      }
    }

    stack.pop();

    return true;
  }
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/unist-util-visit-parents/index.js
// module id = 1043
// module chunks = 0